/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="M.5 2.625a.25.25 0 0 1 .25-.25h22.5a.25.25 0 0 1 .25.25v.1875a.25.25 0 0 1-.25.25H.75a.25.25 0 0 1-.25-.25V2.625Zm0 9.2812a.25.25 0 0 1 .25-.25h22.5a.25.25 0 0 1 .25.25v.1876a.25.25 0 0 1-.25.25H.75a.25.25 0 0 1-.25-.25v-.1876Zm0 9.2813a.25.25 0 0 1 .25-.25h11.4231a.25.25 0 0 1 .25.25v.1875a.25.25 0 0 1-.25.25H.75a.25.25 0 0 1-.25-.25v-.1875Z"
  />,
  'Hamburger'
);
